<template>
    <div>
        <compWrapper
            :title="
                $t('fbb.expresspackage.baseinfo', { defaultValue: '基本信息' })
            "
            theme="primary"
        >
            <compFormQuery
                :formdata="getBase"
                :value="formData"
                :labelWidth="235"
                placeholder="--"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            :title="
                $t('fbb.settlement.alladress', {
                    defaultValue: '收/发货地址信息',
                })
            "
            theme="primary"
        >
            <compFormQuery
                :formdata="getAddress"
                :value="formData"
                :labelWidth="235"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            :title="
                $t('erp.b2c.parcel_information', { defaultValue: '包裹信息' })
            "
            theme="primary"
        >
            <compFormQuery
                v-if="type == 'query'"
                :formdata="getPackage"
                :value="formData"
                :labelWidth="235"
            ></compFormQuery>
            <compFormEdit
                v-else
                ref="relation"
                :formdata="getPackage"
                v-model="formData"
            ></compFormEdit>
        </compWrapper>
        <compWrapper
            :title="$t('fbb.billing.feedetail', { defaultValue: '费用明细' })"
            theme="primary"
        >
            <div
                v-show="formData.status == 'SETTLEMENT_ERROR'"
                class="text-right margin-right-15 margin-top-10"
                v-if="type == 'edit'"
            >
                <Button type="success" @click="saveCost1">保存费用明细</Button>
            </div>
            <div
                v-show="formData.status != 'SETTLEMENT_ERROR'"
                class="text-right margin-right-15 margin-top-10"
                v-if="type == 'edit'"
            >
                <Button type="success" @click="saveCost">保存费用明细</Button>
            </div>
            <compTablelist
                v-show="formData.status == 'SETTLEMENT_ERROR'"
                class="margin-layout"
                :columns="columns"
                :data="errorList"
            ></compTablelist>
            <compTablelist
                v-show="formData.status != 'SETTLEMENT_ERROR'"
                class="margin-layout"
                :columns="columns"
                v-bind="getCostDetail"
            ></compTablelist>
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.operate_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
            v-if="query"
        >
            <compLog
                class="margin-15"
                :data="opLogList"
                :columns="getLogcolumns"
            ></compLog>
        </compWrapper>
        <div class="text-right">
            <vButton
                class="width-15per margin-left-10"
                v-if="!query"
                theme="primary"
                @click="submit"
                >{{
                    this.$t("global.common.save", { defaultValue: "保存" })
                }}</vButton
            >
            <vButton class="width-15per margin-left-10" @click="cancel">{{
                this.$t("global.common.return", { defaultValue: "返回" })
            }}</vButton>
        </div>
        <!-- 全局弹框 -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show = false"
        >
            <component
                ref="cusref"
                :is="modalProps.component"
                v-bind="modalProps"
                v-on="modalProps.on"
            ></component>
        </compModal>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>
<script>
import {
    HttpSettlementOne,
    HttpEditSettlement,
    HttpSettlementCostDetail,
    HttpSettlementCostDetailError,
    HttpGetLog,
    HttpConfirmSettlementCost,
    HttpConfirmSettlementCostError,
} from "@/service/fedex";
import { mapState, mapGetters } from "vuex";
import mixin from "../fedexcost/mixin";

export default {
    mixins: [mixin],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compTablelist: () => import("@components/templates/tablelist"),
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            query: false,
            opLogList: [],
            dataList: [],
            errorList: [],
            formData: {
                // remark:'',
            },
            modalProps: {
                show: false,
                title: "",
                component: null,
            },
            flag: false,
        };
    },
    created() {
        // console.log(this.$route.params.type)
        this.query = this.type === "query";
        this.getDetail();
    },
    computed: {
        ...mapGetters("dictionary", ["getBillcusWareList"]),
        getCostDetail() {
            return {
                initFormData: {
                    "search[EQ_parentId]": this.id,
                    rows: 1000,
                },
                startUp: true,
                ajaxRequest: HttpSettlementCostDetail,
                interceptResponse: (data) => {
                    this.dataList = data.content;
                },
            };
        },

        getBase() {
            const { status, orgWarehouseName, orgWarehouseCode } =
                this.formData;
            return [
                {
                    label: "Tracking NO",
                    key: "trackingNo",
                },
                {
                    label: this.$t("global.common.organization", {
                        defaultValue: "组织",
                    }),
                    key: "orgName",
                },
                {
                    label: this.$t("global.common.project", {
                        defaultValue: "项目",
                    }),
                    key: "lineName",
                    // valueText:`${this.formData.warehouseCode}(${this.formData.warehouseTitle})`
                },
                {
                    label: this.$t("fbb.bill.carrier", {
                        defaultValue: "承运商",
                    }),
                    // label: "物流产品",
                    key: "groupName",
                },
                {
                    label: this.$t("global.common.status", {
                        defaultValue: "状态",
                    }),
                    valueText: {
                        SETTLEMENTED: this.$t("fbb.costmanage.caculated", {
                            defaultValue: "已结算",
                        }),
                        SETTLEMENT_ERROR: this.$t(
                            "fbb.costmanage.caculate_error",
                            { defaultValue: "结算异常" }
                        ),
                        PROCESSED: this.$t("fbb.costmanage.processed", {
                            defaultValue: "待处理",
                        }),
                    }[status],
                },
                {
                    label: this.$t("global.common.warehouse", {
                        defaultValue: "仓库",
                    }),
                    render: () => {
                        let orgWarehouseCode = this.formData.orgWarehouseCode;
                        let orgWarehouse =
                            this.getBillcusWareList.filter((item) => {
                                return item.attach.code == orgWarehouseCode;
                            })[0] || {};
                        return <div>{orgWarehouse.label}</div>;
                    },
                },
                {
                    label: this.$t("fbb.adjustment.list_sourceno", {
                        defaultValue: "关联单号",
                    }),
                    key: "sourceNo",
                },
                {
                    label: this.$t("erp.b2border.invoice", {
                        defaultValue: "发票号",
                    }),
                    key: "invoiceNo",
                },
                {
                    label: this.$t("global.common.createdtime", {
                        defaultValue: "创建时间",
                    }),
                    key: "createdAt",
                },
                {
                    label: this.$t("fbb.settlement.settlementAt", {
                        defaultValue: "结算时间",
                    }),
                    key: "settlementAt",
                },
            ];
        },
        getAddress() {
            return [
                {
                    label: this.$t("fbb.settlement.shipCountry", {
                        defaultValue: "发货地国家",
                    }),
                    key: "shipCountry",
                },
                {
                    label: this.$t("fbb.settlement.shipState", {
                        defaultValue: "发货地州/省",
                    }),
                    key: "shipState",
                },
                {
                    label: this.$t("fbb.settlement.shipCity", {
                        defaultValue: "发货地城市",
                    }),
                    key: "shipCity",
                },
                {
                    label: this.$t("fbb.settlement.shipPostal", {
                        defaultValue: "发货地邮编",
                    }),
                    key: "shipPostal",
                },
                {
                    label: this.$t("fbb.inbound.shipper_address", {
                        defaultValue: "发货方地址",
                    }),
                    key: "shipAddress",
                },
                {
                    label: this.$t("fbb.settlement.receiveCountry", {
                        defaultValue: "收货地国家",
                    }),
                    key: "receiveCountry",
                },
                {
                    label: this.$t("fbb.settlement.receiveState", {
                        defaultValue: "收货地州/省",
                    }),
                    key: "receiveState",
                },
                {
                    label: this.$t("fbb.settlement.receiveCity", {
                        defaultValue: "收货地城市",
                    }),
                    key: "receiveCity",
                },
                {
                    label: this.$t("fbb.settlement.receivePostal", {
                        defaultValue: "收货地邮编",
                    }),
                    key: "receivePostal",
                },
                {
                    label:
                        this.$t("fbb.receiver.query", {
                            defaultValue: "收货地址",
                        }) + "1",
                    key: "receiveAddress1",
                },
                {
                    label:
                        this.$t("fbb.receiver.query", {
                            defaultValue: "收货地址",
                        }) + "2",
                    key: "receiveAddress2",
                },
            ];
        },
        getPackage() {
            return [
                {
                    label: this.$t("global.common.length", {
                        defaultValue: "长",
                    }),
                    key: "length",
                    children(h) {
                        return (
                            <span
                                slot="append"
                                class="padding-left-10 padding-right-10"
                            >
                                {this.formData.sizeUnit}
                            </span>
                        );
                    },
                    show: this.type != "query",
                },
                {
                    label: this.$t("global.common.length", {
                        defaultValue: "长",
                    }),
                    valueText: `${this.formData.length} ${this.formData.sizeUnit}`,
                    show: this.type == "query",
                },
                {
                    label: this.$t("global.common.width", {
                        defaultValue: "宽",
                    }),
                    key: "width",
                    children(h) {
                        return (
                            <span
                                slot="append"
                                class="padding-left-10 padding-right-10"
                            >
                                {this.formData.sizeUnit}
                            </span>
                        );
                    },
                    show: this.type != "query",
                },
                {
                    label: this.$t("global.common.width", {
                        defaultValue: "宽",
                    }),
                    valueText: `${this.formData.width} ${this.formData.sizeUnit}`,
                    show: this.type == "query",
                },
                {
                    label: this.$t("global.common.height", {
                        defaultValue: "高",
                    }),
                    key: "height",
                    children(h) {
                        return (
                            <span
                                slot="append"
                                class="padding-left-10 padding-right-10"
                            >
                                {this.formData.sizeUnit}
                            </span>
                        );
                    },
                    show: this.type != "query",
                },
                {
                    label: this.$t("global.common.height", {
                        defaultValue: "高",
                    }),
                    valueText: `${this.formData.height} ${this.formData.sizeUnit}`,
                    show: this.type == "query",
                },
                {
                    label: this.$t("global.common.weight", {
                        defaultValue: "重量",
                    }),
                    key: "weight",
                    children(h) {
                        return (
                            <span
                                slot="append"
                                class="padding-left-10 padding-right-10"
                            >
                                {this.formData.weightUnit}
                            </span>
                        );
                    },
                    show: this.type != "query",
                },
                {
                    label: this.$t("global.common.weight", {
                        defaultValue: "重量",
                    }),
                    valueText: `${this.formData.weight} ${this.formData.weightUnit}`,
                    show: this.type == "query",
                },
            ];
        },

        columns() {
            return [
                {
                    title: this.$t("fbb.billmanage.bill_no", {
                        defaultValue: "账单编号",
                    }),
                    key: "billNo",
                },
                {
                    title: this.$t("global.common.status", {
                        defaultValue: "状态",
                    }),
                    render: (h, { row }) => {
                        switch (row.status) {
                            case "PROCESSED":
                                return this.$t("fbb.costmanage.processed", {
                                    defaultValue: "待处理",
                                });
                                break;
                            case "DEDUCTIONED":
                                return this.$t("fbb.costmanage.deductioned", {
                                    defaultValue: "已扣款",
                                });
                                break;
                            case "CANCELED":
                                return this.$t("fbb.costmanage.canceled", {
                                    defaultValue: "已作废",
                                });
                                break;
                            case "BILL_CREATED":
                                return this.$t("fbb.costmanage.bill_created", {
                                    defaultValue: "账单已创建",
                                });
                                break;
                            case "BILL_CONFIRMED":
                                return this.$t(
                                    "fbb.costmanage.bill_confirmed",
                                    { defaultValue: "账单已确认" }
                                );
                                break;
                            case "ERROR":
                                return this.$t("fbb.headlogistics.exception", {
                                    defaultValue: "异常",
                                });
                                break;
                        }
                    },
                },
                {
                    title: this.$t("fbb.adjustment.list_costname", {
                        defaultValue: "收费项",
                    }),
                    key: "costName",
                },
                {
                    title: this.$t("fbb.bill.original_billing_amount", {
                        defaultValue: "原始账单金额",
                    }),
                    key: "originalCost",
                },
                {
                    title: "cost",
                    key: "cost",
                    render: (h, { row, index }) => {
                        if (this.type == "edit") {
                            return h("vInput", {
                                props: {
                                    value: row.cost,
                                },
                                on: {
                                    "on-change": (val) => {
                                        if (this.dataList.length > 0) {
                                            this.$set(
                                                this.dataList[index],
                                                "cost",
                                                Number(val)
                                            );
                                        } else {
                                            this.$set(
                                                this.errorList[index],
                                                "cost",
                                                Number(val)
                                            );
                                        }
                                    },
                                },
                            });
                        } else {
                            return row.cost;
                        }
                    },
                },
                {
                    title: this.$t("erp.product_channel.currency", {
                        defaultValue: "币种",
                    }),
                    key: "currency",
                },
                {
                    title: this.$t("global.common.createdtime", {
                        defaultValue: "创建时间",
                    }),
                    key: "createdAt",
                },
            ];
        },
    },
    methods: {
        saveCost() {
            this.modalProps = {
                show: true,
                title: this.$t("fbb.bill.save_expense_details", {
                    defaultValue: "保存费用明细",
                }),
                showDesc: true,
                desc: this.$t("fbb.bill.confirm_whether_save", {
                    defaultValue: "确认是否保存费用明细？",
                }),
                alert: "warning",
                ajaxRequest: async () => {
                    HttpConfirmSettlementCost({
                        id: this.id,
                        freightSettlementItems: this.dataList,
                    }).then(
                        (res) => {
                            this.$Message.success(res.message);
                        },
                        (err) => {
                            this.$Message.error({
                                content: err.message,
                                duration: 5,
                                closable: true,
                            });
                        }
                    );
                },
            };
        },
        saveCost1() {
            if (this.flag) {
                this.modalProps = {
                    show: true,
                    title: this.$t("fbb.bill.save_expense_details", {
                        defaultValue: "保存费用明细",
                    }),
                    showDesc: true,
                    desc: this.$t("fbb.bill.confirm_whether_save", {
                        defaultValue: "确认是否保存费用明细？",
                    }),
                    alert: "warning",
                    ajaxRequest: async () => {
                        HttpConfirmSettlementCost({
                            id: this.id,
                            freightSettlementItems: this.errorList,
                        }).then(
                            (res) => {
                                this.$Message.success(res.message);
                            },
                            (err) => {
                                this.$Message.error({
                                    content: err.message,
                                    duration: 5,
                                    closable: true,
                                });
                            }
                        );
                    },
                };
            } else {
                this.modalProps = {
                    show: true,
                    title: this.$t("fbb.bill.save_expense_details", {
                        defaultValue: "保存费用明细",
                    }),
                    showDesc: true,
                    desc: this.$t("fbb.bill.confirm_whether_save", {
                        defaultValue: "确认是否保存费用明细？",
                    }),
                    alert: "warning",
                    ajaxRequest: async () => {
                        HttpConfirmSettlementCostError({
                            id: this.id,
                            freightSettlementItems: this.errorList,
                        }).then(
                            (res) => {
                                this.$Message.success(res.message);
                            },
                            (err) => {
                                this.$Message.error({
                                    content: err.message,
                                    duration: 5,
                                    closable: true,
                                });
                            }
                        );
                    },
                };
            }
        },
        async getDetail() {
            if (this.type === "add") return;
            this.loading = true;
            HttpSettlementOne({
                id: this.id,
            }).then(
                (res) => {
                    this.handleResponse(res.data);
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );

            if (this.query) {
                // 请求日志的接口
                HttpGetLog({
                    id: this.id,
                    module: 27,
                }).then(
                    (res) => {
                        this.opLogList = res.data;
                    },
                    (err) => {}
                );
            }
        },
        handleResponse(data = {}) {
            this.formData = data;
            // 请求状态错误时费用明细接口
            if (this.formData.status == "SETTLEMENT_ERROR") {
                HttpSettlementCostDetailError({
                    "search[EQ_settlementId]": this.id,
                    rows: 1000,
                }).then((res) => {
                    this.errorList = res.data.content;
                    if (this.errorList.length < 1) {
                        HttpSettlementCostDetail({
                            "search[EQ_parentId]": this.id,
                            rows: 1000,
                        }).then((res) => {
                            this.flag = true;
                            this.errorList = res.data.content;
                        });
                    }
                });
            }
        },
        async submit() {
            const valid = await this.$refs["relation"].validate();
            if (!valid) return;
            this.loading = true;
            HttpEditSettlement({
                id: this.id,
                calculationPackageItem: {
                    sizeUnit: this.formData.sizeUnit,
                    length: this.formData.length,
                    width: this.formData.width,
                    height: this.formData.height,
                    weightUnit: this.formData.weightUnit,
                    weight: this.formData.weight,
                },
            })
                .then((res) => {
                    this.$VMessage.success(res.message);
                    this.$router.push({
                        name: "fedexSettlement",
                    });
                })
                .finally((res) => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$router.push({ name: "fedexSettlement" });
        },
    },
};
</script>
